import script from "./layout-sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./layout-sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./layout-sidebar.vue?vue&type=style&index=0&id=43b2ca1d&lang=less"

const __exports__ = script;

export default __exports__